module.exports = __webpack_public_path__ + "static/media/cart-icon.49e6e0a6.svg";